import http from '@/core/http';

const merchant = {
  actions: {
    // 添加商户
    AddMerchant (ctx, payload) {
      return http.req_post('/admin/action/addaccount', { ...payload });
    },
    // 获取商户列表
    GetMerchantList (ctx, payload) {
      return http.req_get('/admin/action/merlist', { ...payload });
    },
    // 获取商户信息
    GetMerchantInfo (ctx, payload) {
      return http.req_get('/admin/action/merdetail', { ...payload });
    },
    // 获取商户子账户列表
    GetMerchantChildren (ctx, payload) {
      return http.req_get('/admin/action/getchild', { ...payload });
    },
    // 修改商户信息
    SetMerchantInfo (ctx, payload) {
      return http.req_post('/admin/action/savemerdetail', { ...payload });
    },
    // 子账户关联门店
    ChildRelateStores (ctx, payload) {
      return http.req_post('/admin/action/savechildstore', { ...payload });
    },
    // 抖音绑定列表
    DouyinBindList (ctx, payload) {
      return http.req_post('/admin/action/douyinmerlist', { ...payload });
    },
    // 抖音绑定添加/编辑
    DouyinBindAdd (ctx, payload) {
      return http.req_post('/admin/action/savedouyinmer', { ...payload });
    },
    // 高德绑定列表
    GaodeBindList (ctx, payload) {
      return http.req_get('/admin/action/gaodeTuanGou', { ...payload });
    },
    // 高德绑定添加/编辑
    GaodeBindAdd (ctx, payload) {
      return http.req_post('/admin/action/gaodeTuanGouEdit', { ...payload });
    },
    // 商户号列表
    MachIDList (ctx, payload) {
      return http.req_post('/admin/action/mermchidlist', { ...payload });
    },
    // 商户号绑定详情
    MachIDInfo (ctx, payload) {
      return http.req_post('/admin/action/mermchidinfo', { ...payload });
    },
    // 商户号添加
    MachIDAdd (ctx, payload) {
      return http.req_post('/admin/action/addmermchid', { ...payload });
    },
    // 商户号删除
    MachIDDelete (ctx, payload) {
      return http.req_post('/admin/action/delmermchid', { ...payload });
    },
    // 更新商户号分账比例
    UpdateMchID (ctx, payload) {
      return http.req_get('/admin/action/upmchidratio', { ...payload });
    },
    // 获取绑定商户号列表
    GetBindMchList (ctx, payload) {
      return http.req_get('/admin/action2/getBindMchList', { ...payload });
    },
  },
};

export default merchant;